import MembershipSlider from './MembershipSlider'

export default MembershipSlider
